import React, {useState} from 'react';
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {RootState} from "../../../reducers";
import {getUser} from "../../services/User/reducer";
import {getStoreConfig} from "../../services/Store/reducer";
import DateService from "../../services/Common/Date/DateService";
import HoursHelper from "../../services/Menu/services/Availability/HoursHelper";
import StoreInfoModal from "../Modal/StoreInfoModal";
import StoreUtils from "../../services/Store/StoreUtils";
import PopupModal from "../Modal/PopupModal";


interface OwnProps {
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

function NavbarHours(props: Props) {
    const [modal, setModal] = useState(false);
    const {t} = useTranslation();

    if (!props.config) return null;

    const isPaused = StoreUtils.isPaused(props.config);
    const isOpen = HoursHelper.isOpen(props.config.hours, DateService.now());
    const openHours = props.config ? HoursHelper.getOpenHours(props.config.hours, DateService.now()) : undefined;
    const minHours = HoursHelper.closetOpenHours(props.config.hours, DateService.now());

    const showModal = () => {
        setModal(true)
    };

    return (
        <div className="navbar-hours" id="navbar-hours">
            {modal && (
                <StoreInfoModal onHide={() => setModal(false)} />
            )}
            {
                isPaused ? (
                    <button className="btn text-warning btn-sm" onClick={() => showModal()}>
                        <span className="dot bg-status-warning rounded-circle me-2"/>
                        <span className="text">
                            {t("common.word.temporarily_close")}
                        </span>
                    </button>
                    ) : (isOpen ? (
                        <>
                            <button className={"btn text-success btn-sm"} onClick={() => showModal()}>
                                <span className="dot bg-status-success rounded-circle me-2"/>
                                <span className="text">
                                    {t("modules.navbar.field.open.title")}
                                </span>
                            </button>
                        </>
                    ) : (
                        <>
                            {(openHours && openHours.length > 0) ? (
                                <button className={"btn text-warning btn-sm"} onClick={() => showModal()}>
                                    <span className="dot bg-status-warning rounded-circle me-2"/>
                                    <span className="text">
                                        {t("modules.navbar.field.opening_time.title", {hour: minHours})}
                                    </span>
                                </button>
                            ) : (
                                <>
                                    <button className={"btn text-danger btn-sm"} onClick={() => showModal()}>
                                        <span className="dot bg-status-danger rounded-circle me-2"/>
                                        <span className="text">
                                            {t("modules.navbar.field.closed_today.title")}
                                        </span>
                                    </button>
                                </>
                            )}
                        </>
                    ))
            }
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    user: getUser(state.user),
    config: getStoreConfig(state.config)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(NavbarHours));